import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ImagesSvg = function ImagesSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#6356F6",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M13.733 9.43a.8.8 0 0 1 .201.2l3.707 5.22a.833.833 0 0 1-.68 1.317h-3.273l.017.022H7.082a.833.833 0 0 1-.687-1.304l2.435-3.551a.833.833 0 0 1 1.363-.016l.61.847 1.77-2.53a.833.833 0 0 1 1.16-.205M8.25 7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5",
      clipRule: "evenodd"
    })]
  });
};
export var Images = function Images(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: ImagesSvg
  }));
};